export default "__VITE_ASSET__B0Q9j3si__"